import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Sun, CloudSun, Moon, Clock } from 'lucide-react';

const TZ = 'Africa/Mogadishu';

// Returns current hour (0-23) in Somalia local time
const mogadishuHour = () => {
  const h = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', hour12: false }).format(new Date());
  return parseInt(h, 10) % 24;
};

export const greetingFor = (hour) => {
  if (hour < 12) return { so: 'Subax wanaagsan', en: 'Good morning', Icon: Sun };
  if (hour < 18) return { so: 'Duhur wanaagsan', en: 'Good afternoon', Icon: CloudSun };
  return { so: 'Habeen wanaagsan', en: 'Good evening', Icon: Moon };
};

export const firstNameOf = (fullName = '') => (fullName || '').trim().split(/\s+/)[0] || '';

export const Greeting = () => {
  const { user } = useAuth();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);

  const hour = mogadishuHour();
  const { so, en, Icon } = greetingFor(hour);
  const name = firstNameOf(user?.full_name);
  const time = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit' }).format(now);
  const date = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' }).format(now);

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 bg-white border border-slate-200 border-l-[3px] border-l-[#FFC107] px-3 sm:px-4 py-2 mb-4 sm:mb-6"
      data-testid="user-greeting"
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <span className="h-8 w-8 shrink-0 flex items-center justify-center bg-[#0B2545] text-[#FFC107]">
          <Icon className="h-4 w-4" />
        </span>
        <p className="min-w-0 text-[#0B2545] leading-snug text-sm sm:text-[15px] flex flex-col md:flex-row md:items-baseline md:gap-2">
          <span className="font-extrabold truncate" data-testid="greeting-somali">{so} {name}</span>
          <span className="hidden md:inline text-slate-300 font-normal" aria-hidden="true">|</span>
          <span className="font-semibold text-slate-600 truncate" data-testid="greeting-english">{en}, {name}</span>
        </p>
      </div>
      <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 whitespace-nowrap" data-testid="greeting-time">
        <Clock className="h-3.5 w-3.5 text-[#0B2545]" />
        {date} · {time} <span className="hidden sm:inline text-slate-400">Mogadishu</span>
      </span>
    </div>
  );
};

export default Greeting;
